import { createFileRoute } from '@tanstack/react-router';

import ApproveAccount from '@/pages/ApproveAccount';

export const Route = createFileRoute('/_app/approve/$token')({
  component: ApproveAccount,
});
